import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const getDealWiseMyBackrrReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_GET_DEAL_WISE_MY_BACKRR:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_GET_DEAL_WISE_MY_BACKRR_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_GET_DEAL_WISE_MY_BACKRR_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_GET_DEAL_WISE_MY_BACKRR:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default getDealWiseMyBackrrReducer;
